// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "reasons-2ug9u";
var _4 = "reason-3rU9b";
var _5 = "groupTitle-3xbw_";
var _6 = "groupWrapper-Lr2pP";
var _7 = "paper-3Pe3Z";
export { _1 as "__esModule", _2 as "mobile", _3 as "reasons", _4 as "reason", _5 as "groupTitle", _6 as "groupWrapper", _7 as "paper" }
export default { "__esModule": _1, "mobile": _2, "reasons": _3, "reason": _4, "groupTitle": _5, "groupWrapper": _6, "paper": _7 }
